import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React, {Component} from 'react';
import toastr from "toastr";
import Theme from '../common/MuiTheme';
import ChartLoader from '../utils/chart-loader';

import {paginate} from '../utils/paginate'
import http from "../../services/httpService";
import authService, {getJwt} from '../../services/authService';
import {Tooltip, Position, Icon, Popover} from '@blueprintjs/core';
import DeleteShortLinkModal from "../modals/DeleteShortLinkModal";
import sizeMe from 'react-sizeme';

import {
    FacebookShareButton,
    LinkedinShareButton,
    RedditShareButton,
    TwitterShareButton,
    VKShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    RedditIcon,
    VKIcon
} from "react-share";

class URLShortenerPerformance extends Component {
    state = {
        loader: false,
        urls: [],
        tableWidth: '',
        pagesCount: '',
        pageSize: 10,
        selectedPage: 1,
        pages: [],
        shownUrls: [],
        selectedSource: this.props.selectedSource,
        selectedSubTypeFinished: '',
        forceTableRerender: false,
        deleteShortLinkModal: false,
        columnWidths: [300, 400, 100, 100, 1000],
        deleteIndex: '',
        user: this.props.user,
        deleteShortActive: false

    };

    async componentDidMount() {
        window.addEventListener("resize", this.handleResize);

        await this.setState({loader: true})
        try {
            const response = await http.get('https://short.emitto.io/project/' + this.props.selectedSource, {headers: {authorization: getJwt()}});
            //console.log('didMount response: ', response);

            // let pagesCount = await Math.ceil(response.data.data.items.length / this.state.pageSize);
            // let shownUrls = await paginate(this.state.urls, this.state.selectedPage, this.state.pageSize);
            // const tableWidth = document.querySelector('main').offsetWidth - 130;
            // // const colWidth = tableWidth / 4;
            // // const columnWidths = [colWidth, 2 * colWidth, colWidth / 4, 2 * colWidth / 4, 150];
            // let pages = [];
            // let i;
            // for (i = 0; i < pagesCount; i++) {
            //     await pages.push(i + 1);
            // }

            //console.log('didMount  - pagesCount:', pagesCount);

            await this.setState({
                urls: response.data.data.items,
                selectedSubTypeFinished: 'shortener',
                // pagesCount,
                // pages,
                shownUrls: response.data.data.items,
                // columnWidths,
                // tableWidth,
                loader: false
            });
            //console.log('state: ', this.state)
            // this.handleFirstPage();

            // if (!this.state.posts && !this.state.loader) {
            //     await this.recalculateColsWidth(900)
            // }
        } catch (e) {
            //console.log('shorteners error: ', e);
            toastr.error('Something went wrong... Please refresh and try again.');
        }

        //let pagesCount = await Math.ceil(this.state.urls.length / this.state.pageSize);


    }


    getShorteners = async () => {
        if (this.state.selectedSource) {
            if (this.state.selectedSubTypeFinished === 'shortener') {
                await this.setState({
                    selectedSubTypeFinished: ''
                })
            }
            try {
                const response = await http.get('https://short.emitto.io/project/' + this.state.selectedSource, {headers: {authorization: getJwt()}});
                // if (!this.state.posts && !this.state.loader) {
                //     await this.recalculateColsWidth(900)
                // }
                await this.setState(
                    {
                        urls: response.data.data.items,
                        selectedSubTypeFinished: 'shortener',
                    }
                )
            } catch (e) {
                toastr.error('Something went wrong... Please try again.');
            }
        }
    };
    deleteShortCode = async () => {
        // console.log('delete index: ', this.state.deleteIndex);
        // console.log('deleting item: ', this.state.shownUrls[this.state.deleteIndex]);
        this.setState({deleteShortActive: true})
        let shortLink = this.state.shownUrls[this.state.deleteIndex].short_id;
        try {
            //console.log('delete call: ' + 'https://oo.fyi/short-link/' + shortLink);
            const deleteResponse = await http.delete('https://oo.fyi/short-link/' + shortLink,
                {
                    headers: {authorization: authService.getJwt()},
                });

            //console.log('deleteResponse: ', deleteResponse);

            toastr.success('Short link deleted.');
            if (deleteResponse) {
                await this.setState({
                    deleteShortLinkModal: false
                })
                await this.setState({loader: true})
            }
            try {
                const response = await http.get('https://short.emitto.io/project/' + this.props.selectedSource, {headers: {authorization: getJwt()}});
                // console.log('didMount response: ', response);

                let pagesCount = await Math.ceil(response.data.data.items.length / this.state.pageSize);
                let shownUrls = await paginate(response.data.data.items, this.state.selectedPage, this.state.pageSize);
                const tableWidth = document.querySelector('main').offsetWidth - 130;
                const colWidth = tableWidth / 4;
                const columnWidths = [colWidth, 2 * colWidth, colWidth / 4, 2 * colWidth / 4, 150];
                let pages = [];
                let i;
                for (i = 0; i < pagesCount; i++) {
                    await pages.push(i + 1);
                }

                // console.log('didMount  - pagesCount:', pagesCount);

                await this.setState({
                    urls: response.data.data.items,
                    selectedSubTypeFinished: 'shortener',
                    pagesCount,
                    pages,
                    shownUrls,
                    columnWidths,
                    tableWidth,
                    loader: false,
                    deleteShortActive: false
                });
                //console.log('state: ', this.state)
                // this.handleFirstPage();
            } catch (e) {
                toastr.error('Something went wrong... Please try again.');
                this.setState({deleteShortActive: false})
            }

        } catch (e) {
            toastr.error('Something went wrong... Please try again.');
            this.setState({deleteShortActive: false})
        }
    }
    openDeleteModal = () => {
        this.setState({
            deleteShortLinkModal: true
        })
    };

    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            // console.log('shortener performance - didUpdate started')
            // await this.recalculateColsWidth(900)

            //await this.setState({loader: true})
            try {

                const response = await http.get('https://short.emitto.io/project/' + this.props.selectedSource, {headers: {authorization: getJwt()}});
                //console.log('https://short.emitto.io/project/'+this.props.selectedSource)
                //console.log('didMount response: ', response);

                // let pagesCount = await Math.ceil(response.data.data.items.length / this.state.pageSize);
                // let shownUrls = await paginate(this.state.urls, this.state.selectedPage, this.state.pageSize);
                // const tableWidth = document.querySelector('main').offsetWidth - 130;
                // // const colWidth = tableWidth / 4;
                // // const columnWidths = [colWidth, 2 * colWidth, colWidth / 4, 2 * colWidth / 4, 150];
                // let pages = [];
                // let i;
                // for (i = 0; i < pagesCount; i++) {
                //     await pages.push(i + 1);
                // }

                //console.log('didMount  - pagesCount:', pagesCount);

                await this.setState({
                    urls: response.data.data.items,
                    selectedSubTypeFinished: 'shortener',
                    // pagesCount,
                    // pages,
                    shownUrls: response.data.data.items,
                    // columnWidths,
                    // tableWidth,
                    loader: false,
                    selectedSource: this.props.selectedSource
                });
                //console.log('state: ', this.state)
                // this.handleFirstPage();

                // if (!this.state.posts && !this.state.loader) {
                //     await this.recalculateColsWidth(900)
                // }
            } catch (e) {

                //console.log('shorteners error: ', e);
                toastr.error('Something went wrong... Please try again.');
            }
        }
    }


    // handlePageChange = async (event) => {
    //     //console.log('page changed item:', event.target.value);
    //     let pageNumber = parseInt(event.target.value);
    //     // console.log('page number: ', pageNumber)
    //     const shownUrls = await paginate(this.state.urls, pageNumber, this.state.pageSize);
    //     // console.log('shown urls: ', shownUrls)
    //     let tableWidth = this.state.tableWidth;
    //     await this.setState({
    //         shownUrls,
    //         selectedPage: pageNumber,
    //         forceTableRerender: true,
    //         tableWidth
    //     })
    //     await this.setState({
    //             forceTableRerender: false
    //         }
    //     )
    // };

    noUrlRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img alt='URL shortener campaigns' src="/img/emptyStates/url_shortener_my_campaigns.gif"/>
            <h3>It looks like you don't have any shortened URLs.</h3>
            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                <button
                    onClick={() => this.props.history.push('/url/shortener')}
                    className=' btn-action margin-bottom-10'>
                    Shorten an URL
                </button>
            </div>
        </div>
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    getMuiTheme = () => createTheme(Theme)

    copyToClipboard = (id) => {

        let textArea = document.createElement("textarea");
        textArea.value = id;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("Copy");
        textArea.remove();
        toastr.success('Link copied to clipboard.')
    };

    render() {
        const columns = [
            {
                name: "short_url",
                label: "Short URL",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return <div className='min-width-160'>
                            <span
                                onClick={() => this.copyToClipboard(this.state.shownUrls[tableMeta.rowIndex] ? this.state.shownUrls[tableMeta.rowIndex].short_url : '')}
                                className='fas fa-copy'></span>
                            <span
                                id={this.state.shownUrls[tableMeta.rowIndex] ? this.state.shownUrls[tableMeta.rowIndex].short_url : ''}
                                className='short-url'>
                                {this.state.shownUrls[tableMeta.rowIndex] ? this.state.shownUrls[tableMeta.rowIndex].short_url : ''}
                            </span>
                        </div>
                    }
                },
            },
            {
                name: "source_url",
                label: "Source URL",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let spaces = false;
                        if (this.state.shownUrls[tableMeta.rowIndex]) {

                            if (this.state.shownUrls[tableMeta.rowIndex].title) {
                                if (!this.state.shownUrls[tableMeta.rowIndex].title.replace(/\s/g, '').length) {
                                    spaces = true
                                }
                            }
                        }
                        return <div className='mui-column-wrapper'>
                            {this.state.shownUrls[tableMeta.rowIndex] ? this.state.shownUrls[tableMeta.rowIndex].title ?

                                spaces ? <p>{this.state.shownUrls[tableMeta.rowIndex].original_url}</p> :
                                    (
                                        <Tooltip content={this.state.shownUrls[tableMeta.rowIndex].original_url}
                                                 position={Position.TOP}>

                                            <p className='url-title'>{this.state.shownUrls[tableMeta.rowIndex].title}</p>
                                        </Tooltip>
                                    )

                                : this.state.shownUrls[tableMeta.rowIndex].original_url : ''}
                        </div>
                    }
                }
            },
            {
                name: "clicks",
                label: "Clicks",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return <div>
                            {this.state.shownUrls[tableMeta.rowIndex] ? this.state.shownUrls[tableMeta.rowIndex].hits : ''}
                        </div>
                    }
                }
            },
            {
                name: "date",
                label: "Date",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // let date = '';
                        // if (this.state.shownUrls[tableMeta.rowIndex]) {
                        //
                        //     date = moment(this.state.shownUrls[tableMeta.rowIndex].created_at_timezone).format('DD-MM-YYYY')
                        //     if (this.state.user.locals) {
                        //         date = moment(this.state.shownUrls[tableMeta.rowIndex].created_at_timezone).format(this.state.user.locals.date_format)
                        //     }
                        //
                        // }
                        const item = this.state.shownUrls[tableMeta.rowIndex];
                        let dateConverted = item && item.created_at ? this.props.isodateToDate(item.created_at) : ''
                        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
                        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';

                        return <div className='min-width-80 mui-column-wrapper'>
                            <p>{date}</p>
                        </div>
                    }
                }
            },
            {
                name: "clicks",
                label: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return this.state.shownUrls && this.state.shownUrls[tableMeta.rowIndex] ?
                            <div className="min-width-70 display-flex flex-direction-row flex-start">
                                <Popover
                                    content={this.popoverContent}
                                    position={this.state.shownUrls.length > 3 ? Position.TOP : Position.LEFT}

                                >
                                    <Icon icon='share' className='shortener-action '/>
                                    <div className='shortener-actions-container padding-10'>
                                        <p>Easy share via:</p>
                                        <div className="form-group social-container">

                                            <FacebookShareButton
                                                url={this.state.shownUrls[tableMeta.rowIndex].short_url}>
                                                <FacebookIcon size={32} round={true}/>
                                            </FacebookShareButton>
                                            <TwitterShareButton
                                                url={this.state.shownUrls[tableMeta.rowIndex].short_url}>
                                                <TwitterIcon size={32} round={true}/>
                                            </TwitterShareButton>
                                            <LinkedinShareButton
                                                url={this.state.shownUrls[tableMeta.rowIndex].short_url}>
                                                <LinkedinIcon size={32} round={true}/>
                                            </LinkedinShareButton>
                                            <VKShareButton url={this.state.shownUrls[tableMeta.rowIndex].short_url}>
                                                <VKIcon size={32} round={true}/>
                                            </VKShareButton>
                                            <RedditShareButton url={this.state.shownUrls[tableMeta.rowIndex].short_url}>
                                                <RedditIcon size={32} round={true}/>
                                            </RedditShareButton>
                                        </div>
                                    </div>
                                </Popover>
                                <Icon icon='annotation'
                                      onClick={() => this.props.editShortenedUrl(tableMeta.rowIndex, this.state.shownUrls)}

                                      className='shortener-action'/>
                                <Icon icon='trash' onClick={
                                    () => {
                                        this.setState({deleteIndex: tableMeta.rowIndex});
                                        this.openDeleteModal()
                                    }
                                } className='shortener-action'/>
                            </div>
                            :
                            <div/>
                    }
                }
            },
        ];

        const options = {
            serverSide: false,
            // count: this.state.totalPosts,
            filterType: 'none',
            selectableRows: 'none',
            // rowsPerPage: this.state.pageSize,
            viewColumns: false,
            download: false,
            print: false,
            search: false,
            filter: false,
            sort: false,
            // onChangeRowsPerPage: (number) => this.handleChangeCampaignsNumberPerPage(number),
            // page: this.state.currentPage - 1,
            rowsPerPageOptions: [10, 25, 50, 100],
            // rowsSelected: this.state.rowsSelected,
            textLabels: {
                body: {
                    noMatch: this.state.loader ?
                        this.tableLoaderRenderer()
                        :
                        'Sorry, there is no matching data to display',
                },
            },
        };

        return (
            <div className="d-block">
                {
                    this.state.loader ?
                        this.tableLoaderRenderer()
                        :
                        (!this.state.urls || this.state.urls.length < 1) && !this.state.loader ?
                            this.noUrlRenderer()
                            :
                            <MuiThemeProvider theme={this.getMuiTheme()}>
                                <MUIDataTable
                                    title={""}
                                    data={this.state.urls}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                }
                <DeleteShortLinkModal
                    showModal={this.state.deleteShortLinkModal}
                    handleClose={() => this.setState({deleteShortLinkModal: false})}
                    maxWidth={540}
                    history={this.props.history}
                    deleteShortCode={this.deleteShortCode}
                    loaderActive={this.state.deleteShortActive}
                />
            </div>

        )
    }
}

export default sizeMe()(URLShortenerPerformance);